// "Ready for the next step?" — the friendly account-creation checkpoint shown to
// signed-out visitors (Support Desk progress, finish panel, landing reminder).
// It explains the three access levels honestly: free intro (no account), free
// registered account, and future premium features (not available yet).
import { h } from './h.js';
import { supabaseConfigured } from '../auth/supabaseClient.js';

export const ACCOUNT_BENEFITS = [
  'Save your completed Support Desk tickets.',
  'Earn XP and track your level.',
  'Continue your learning across sessions and devices.',
  'Build your RouteZero profile.',
  'Follow your next learning target.',
  'Continue into the Network Engineer missions.',
];

/** What "saved" means: real accounts save to the RouteZero account service; the development build only to this browser. */
export const ACCOUNT_SAVE_NOTE = 'Your free account saves your progress online, so you can sign in and continue on any device.';
export const DEV_SAVE_NOTE = 'Development build: accounts and progress are kept in this browser only (no account service connected).';
export const saveNote = (accounts = supabaseConfigured()) => (accounts ? ACCOUNT_SAVE_NOTE : DEV_SAVE_NOTE);

export function accessTiers() {
  return h('ul', { class: 'rz-tiers', 'data-testid': 'access-tiers' },
    h('li', {}, h('b', {}, 'Free introduction'), h('span', {}, 'The Level 1 Support Desk — no account needed. Work is kept temporarily in this browser.')),
    h('li', {}, h('b', {}, 'Free RouteZero account'), h('span', {}, 'Keeps your progress and XP and opens the Network Engineer missions. No payment required.')),
    h('li', { class: 'future' }, h('b', {}, 'Premium (future)'), h('span', {}, 'Optional extra features may be offered later. Nothing is for sale today.')));
}

/**
 * @param {{ testid?: string, compact?: boolean, onDismiss?: () => void, heading?: string }} o
 */
export function registrationCheckpoint({ testid = 'signup-checkpoint', compact = false, onDismiss = null, heading = 'Ready for the next step?' } = {}) {
  return h('section', { class: `panel rz-checkpoint ${compact ? 'compact' : ''}`, 'data-testid': testid, 'aria-labelledby': `${testid}-title` },
    h('div', { class: 'rz-checkpoint-copy' },
      h('div', { class: 'eyebrow' }, 'FREE ACCOUNT'),
      h('h2', { id: `${testid}-title` }, heading),
      h('p', { class: 'rz-checkpoint-lede' }, h('b', {}, 'Create your free RouteZero account.'), ' Keep your progress and continue your journey from IT support into network engineering.'),
      h('ul', { class: 'rz-benefits' }, (compact ? ACCOUNT_BENEFITS.slice(0, 3) : ACCOUNT_BENEFITS).map((b) => h('li', {}, b))),
      h('div', { class: 'rz-checkpoint-cta' },
        h('a', { class: 'btn primary', href: '#/signup', 'data-testid': `${testid}-create` }, 'CREATE FREE ACCOUNT'),
        h('a', { class: 'btn ghost', href: '#/login', 'data-testid': `${testid}-signin` }, 'SIGN IN'),
        onDismiss ? h('button', { class: 'btn ghost small', type: 'button', 'data-testid': `${testid}-dismiss`, onclick: onDismiss }, 'Keep going as a guest') : null),
      h('p', { class: 'small muted rz-proto-note', 'data-testid': `${testid}-save-note` }, saveNote())),
    compact ? null : accessTiers());
}
